import FarmCard from './FarmCard'
import PropTypes from 'prop-types'
import React from 'react'
import Typography from 'material-ui/Typography'
import { withStyles } from 'material-ui/styles'

const styles = theme => ({
  farmListHeader: {
    backgroundColor: 'gold',
    textAlign: 'left',
  },
  farmListBody: {
    height: '100%',
    overflow: 'scroll',
  },
})

const FarmList = ({
  classes,
  className,
  farms,
  changeActiveWindow,
  getFarmInfo,
}) => (
  <div className={className}>
    <div className={classes.farmListHeader}>
      <Typography component='h2' type='headline'>
        Farms
      </Typography>
    </div>
    <div className={classes.farmListBody}>
      {farms.map((farm, index) => (
        <FarmCard
          address={farm.Address}
          changeActiveWindow={changeActiveWindow}
          city={farm.City}
          farmId={farm.FarmID}
          getFarmInfo={getFarmInfo}
          key={index}
          name={farm.Name}
          state={farm.State}
          website={farm.Website}
          zip={farm.Zip}
        />
      ))}
    </div>
  </div>
)

export default withStyles(styles)(FarmList)



// WEBPACK FOOTER //
// ./src/components/FarmList.js